export const USER_INFO = 'user_info';
export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh_token';
export const REMEMBER_ME_TOKEN = 'remember_me_token';
export const POLICY_REF = 'policy_ref';
export const CURRENT_SEARCHED_USER = 'current_searched_user';
